import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
    mutations: {
      retry: 0,
    },
  },
});

export const queryKeys = {
  me: ['users', 'me'] as const,
  publicConfig: ['config', 'public'] as const,
  readingsList: (limit: number) => ['readings', 'list', { limit }] as const,
  reading: (id: number) => ['readings', 'detail', id] as const,
  readingJob: (jobId: string) => ['readings', 'job', jobId] as const,
  paymentPackages: ['payments', 'packages'] as const,
};
